import React, { useCallback, useRef, useState } from 'react';

import { Container, Content, Background, AnimatedDiv } from './styles';
import SignupCodeIntegration from '../../components/SignupCodeIntegration';

const SignUp: React.FC = () => {
  return (
    <Container>
      <Content style={{ paddingTop: '100px' }}>
        <SignupCodeIntegration />
      </Content>
    </Container>
  );
};

export default SignUp;
